import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Label, Table } from "reactstrap";
import {
	UpdateNavBarItem,
	UpdateNavBarTab,
} from "../../components/navbarRedux/action";

function SpWorkStationModal(props) {
	let history = useHistory();
	return (
		<>
			<Modal
				show={props.showSpWorkStationModal}
				onHide={props.handleClose}
				aria-labelledby="contained-modal-title-vcenter"
				centered
				size="xl"
				className="project-modal"
			>
				<Modal.Header
					closeButton
					style={{ padding: "1rem 15px 45px 18px" }}
				>
					{"TEAM WORK STATION"}
				</Modal.Header>
				<Modal.Body className="modal-body">
					{
						<>
							<div>
								<Table>
									<thead>
										<tr>
											<th>EMPLOYEE NAME</th>
											<th>WORK FROM OFFICE</th>
											<th>WORK FROM HOME</th>
											<th>CONTINUING WORK FROM OFFICE</th>
										</tr>
									</thead>
									<tbody>
										{props.SpWorkStationModalEmp && (
											<tr
												style={{
													backgroundColor:
														"#43998684",
												}}
											>
												<td>
													<Label
														className="supTeamWSModalLabel"
														onClick={() => {
															sessionStorage.setItem(
																"NavbarTab",
																"SupervisorTasks"
															);
															sessionStorage.setItem(
																"NavbarItem",
																"CheckInCheckOut"
															);
															props.UpdateNavBarTab(
																"SupervisorTasks"
															);
															props.UpdateNavBarItem(
																"CheckInCheckOut"
															);
															history.push(
																`/CheckInCheckOut/${props.SpWorkStationModalEmp.employeeId}`
															);
														}}
													>
														{
															props
																.SpWorkStationModalEmp
																.employeeName
														}
													</Label>
												</td>
												<td>
													{
														props
															.SpWorkStationModalEmp
															.workFromOffice
													}
												</td>
												<td>
													{
														props
															.SpWorkStationModalEmp
															.workFromHome
													}
												</td>
												<td>
													{
														props
															.SpWorkStationModalEmp
															.continuingWorkFromOffice
													}
												</td>
											</tr>
										)}

										{props.showALLEmployeeWSData &&
											props.ALLEmployeeWSData.map(
												(emp, i) =>
													emp.employeeName !=
													props.SpWorkStationModalEmp
														.employeeName ? (
														<tr
															key={i}
															className={
																i % 2 === 0
																	? "bgColor2"
																	: "bgColor1"
															}
														>
															<td>
																<Label
																	className="supTeamWSModalLabel"
																	onClick={() => {
																		sessionStorage.setItem(
																			"NavbarTab",
																			"SupervisorTasks"
																		);
																		sessionStorage.setItem(
																			"NavbarItem",
																			"CheckInCheckOut"
																		);
																		props.UpdateNavBarTab(
																			"SupervisorTasks"
																		);
																		props.UpdateNavBarItem(
																			"CheckInCheckOut"
																		);
																		history.push(
																			`/CheckInCheckOut/${emp.employeeId}`
																		);
																	}}
																>
																	{
																		emp.employeeName
																	}
																</Label>
															</td>
															<td>
																{
																	emp.workFromOffice
																}
															</td>
															<td>
																{
																	emp.workFromHome
																}
															</td>
															<td>
																{
																	emp.continuingWorkFromOffice
																}
															</td>
														</tr>
													) : null
											)}
									</tbody>
								</Table>
							</div>
							<div className="text-center">
								<Button
									className="submit-btn"
									style={{
										width: "200px",
										background: "#068587",
									}}
									onClick={props.onshowALLEmployeeWSDataClick}
								>
									{props.showALLEmployeeWSData
										? "Hide All Employees"
										: "View All Employees"}
								</Button>
							</div>
						</>
					}
				</Modal.Body>
			</Modal>
		</>
	);
}
const mapDispatchToProps = {
	UpdateNavBarItem,
	UpdateNavBarTab,
};
export default connect(null, mapDispatchToProps)(SpWorkStationModal);
